import React from 'react';

import { Icon, Segment } from '@mairistem/composants';

// import { Section } from '@mairistem/administres-utils';
import { Section } from '@/components/Common';
import { AssistantContext } from '@/contexts';
import { COLORS } from '@/constants';

interface StepTypeDeclarationProps {
  /** Callback appelé à la sélection d'un type de déclaration */
  onSelect?: () => void;
}

const StepTypeDeclaration = (props: StepTypeDeclarationProps) => {
  const { onSelect } = props;

  const {
    setIsDissolutionMode,
    selectedDeclarationType,
    setSelectedDeclarationType,
  } = React.useContext(AssistantContext);

  const handleSegmentClick = React.useCallback(
    (type: string, isDissolution: boolean) => {
      setSelectedDeclarationType(type);
      setIsDissolutionMode(isDissolution);
      onSelect?.();
    },
    [setIsDissolutionMode, setSelectedDeclarationType, onSelect],
  );

  const getSegmentStyle = (type: string) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    backgroundColor:
      selectedDeclarationType === type ? COLORS.Background : undefined,
    margin: 0,
    color: selectedDeclarationType === type ? 'white' : undefined,
  });

  return (
    <Section
      data-testid="assistant-type-declaration"
      title="SÉLECTION DU TYPE DE DÉCLARATION DE PACS"
      style={{ width: '65%', justifyContent: 'center', padding: '2em' }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1em',
          width: '100%',
          overflowY: 'auto',
        }}
      >
        <Segment
          className="assistant-type-declaration-segment"
          data-testid="assistant-type-declaration-projet"
          onClick={() => handleSegmentClick('projet', false)}
          style={getSegmentStyle('projet')}
        >
          <Icon
            style={{
              height: '5em',
              width: '5em',
              marginRight: '1em',
              flexShrink: 0,
            }}
            iconSet="Lucide"
            name="Clock4"
          />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              minHeight: '80px',
            }}
          >
            <div style={{ margin: 0 }}>
              <h5>Projet de PACS</h5>
            </div>
            <div style={{ margin: 0, padding: 0 }}>
              <ul style={{ listStyleType: 'none', margin: 0, padding: 0 }}>
                Le projet de pacs permet :
                <li>- la constitution du dossier de PACS</li>
                <li>
                  - la vérification d&apos;absence d&apos;empêchement au PACS
                </li>
              </ul>
            </div>
          </div>
        </Segment>
        <Segment
          className="assistant-type-declaration-segment"
          data-testid="assistant-type-declaration-initiale"
          onClick={() => handleSegmentClick('initiale', false)}
          style={getSegmentStyle('initiale')}
        >
          <Icon
            style={{
              height: '5em',
              width: '5em',
              marginRight: '1em',
              flexShrink: 0,
            }}
            iconSet="Lucide"
            name="Clock4"
          />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              minHeight: '80px',
            }}
          >
            <div style={{ margin: 0, padding: 0 }}>
              <h5>Déclaration initiale</h5>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <span>
                La déclaration initiale de PACS doit être conclu devant
                l&apos;officer d&apos;état civil de la commune dans laquelle les
                futurs partenaires fixent leur résidence commune
              </span>
            </div>
          </div>
        </Segment>
        <Segment
          className="assistant-type-declaration-segment"
          data-testid="assistant-type-declaration-modificative"
          onClick={() => handleSegmentClick('modificative', false)}
          style={getSegmentStyle('modificative')}
        >
          <Icon
            style={{
              height: '5em',
              width: '5em',
              marginRight: '1em',
              flexShrink: 0,
            }}
            iconSet="Lucide"
            name="Clock4"
          />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              minHeight: '80px',
            }}
          >
            <div style={{ margin: 0, padding: 0 }}>
              <h5>Déclaration modificative</h5>
            </div>
            <div style={{ margin: 0, padding: 0 }}>
              <ul style={{ listStyleType: 'none', margin: 0, padding: 0 }}>
                La déclaration modificative de PACS doit être enregistrée par
                vos soins dans les cas suivants :
                <li>
                  - concernant un PACS enregistré par un tribunal d&apos;
                  instance situé sur votre territoire avant le 1er novembre 2017
                </li>
                <li>
                  - concernant un PACS initial enregistré dans votre mairie
                  après le 1er novembre 2017
                </li>
              </ul>
            </div>
          </div>
        </Segment>
        <Segment
          className="assistant-type-declaration-segment"
          data-testid="assistant-type-declaration-dissolution"
          onClick={() => handleSegmentClick('dissolution', true)}
          style={getSegmentStyle('dissolution')}
        >
          <Icon
            style={{
              height: '5em',
              width: '5em',
              marginRight: '1em',
              flexShrink: 0,
            }}
            iconSet="Lucide"
            name="Clock4"
          />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              minHeight: '80px',
            }}
          >
            <div style={{ margin: 0, padding: 0 }}>
              <h5>Déclaration de dissolution</h5>
            </div>
            <div style={{ margin: 0, padding: 0 }}>
              <ul style={{ listStyleType: 'none', margin: 0, padding: 0 }}>
                La déclaration de dissolution de PACS peut survenir dans les cas
                suivants :
                <li>
                  - après le mariage des partenaires ou le décès d&apos;un des
                  partenaires
                </li>
                <li>
                  - par décision unilatérale ou commune des deux partenaires
                </li>
              </ul>
            </div>
          </div>
        </Segment>
      </div>
    </Section>
  );
};

export default StepTypeDeclaration;
